import toast from "react-hot-toast";
import {
  ORDER_COM_COOK_STATUS,
  ORDER_COM_SERVING_STATUS,
  ORDER_COM_STATUS,
  ORDER_READY_STATUS,
  ORDER_START_DEL_STATUS,
  ORDER_WAIT_STATUS,
} from "../recoil/type";
// import UtilController from "../controller/UtilController";

declare global {
  interface Window {
    kakao: any;
  }
}

export const moveListItemBack = (arr: any[], index: number) => {
  if (index < 0 || index >= arr.length - 1) {
    console.log("Invalid index.");
    return arr;
  }

  const item = arr.splice(index, 1)[0];
  arr.splice(index + 1, 0, item);

  return arr;
};

export const moveItemForward = (arr: any[], index: number) => {
  if (index <= 0 || index >= arr.length) {
    console.log("Invalid index.");
    return arr;
  }

  const item = arr.splice(index, 1)[0];
  arr.splice(index - 1, 0, item);

  return arr;
};

export const sendInterval = (
  count: number,
  setTimer: (time: number) => void,
  onTimeout: () => void
) => {
  setTimer(count);
  let countValue = count;

  const timer = setInterval(() => {
    if (countValue > 0) {
      countValue = countValue - 1;
      setTimer(countValue);
    } else {
      clearInterval(timer);
      onTimeout();
    }
  }, 1000);

  return timer;
};

export const formatPhoneNumber = (phoneNumber: string) => {
  const cleaned = ("" + phoneNumber).replace(/\D/g, "");
  let formatted = cleaned;
  if (cleaned.length === 9)
    formatted = cleaned.replace(/(\d{2})(\d{3})(\d{4})/, "$1-$2-$3");
  else if (cleaned.length === 10)
    formatted = cleaned.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
  else formatted = cleaned.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
  return formatted;
};

export const formatBusinessNumber = (businessNumber: string) => {
  const cleaned = ("" + businessNumber).replace(/\D/g, "");
  let formatted = cleaned;
  if (cleaned.length === 10)
    formatted = cleaned.replace(/(\d{3})(\d{2})(\d{5})/, "$1-$2-$3");
  return formatted;
};

export const formatCardNumber = (cardNumber: string) => {
  const cleaned = ("" + cardNumber).replace(/\D/g, "");
  let formatted = cleaned;
  if (cleaned.length === 16)
    formatted = cleaned.replace(/(\d{4})(\d{4})(\d{4})(\d{4})/, "$1-$2-$3-$4");
  return formatted;
};

export const formatValidPeriod = (validPeriod: string) => {
  const cleaned = ("" + validPeriod).replace(/\D/g, "");
  let formatted = cleaned;
  if (cleaned.length === 4)
    formatted = cleaned.replace(/(\d{2})(\d{2})/, "$1/$2");
  return formatted;
};

export const formatCardCompany = (company: string) => {
  const cleaned = ("" + company).replace(/\[|\]|카드/g, "");
  return cleaned;
};

export const shufflePassword = () => {
  const array = Array.from({ length: 10 }, (_, index) => index);
  const dividedArray = [];

  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  for (let i = 0; i < 10; i += 3) {
    const dividedSource = array.slice(i, i + 3);
    dividedArray.push(dividedSource);
  }

  return dividedArray;
};

export const getCurrentLocation = (): Promise<{
  latitude: number;
  longitude: number;
}> => {
  return new Promise((resolve, reject) => {
    if ("geolocation" in navigator) {
      /*
      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
        },
        (error) => {
          reject(error);
        }
      );
      */
      var ua = navigator.userAgent.toLowerCase(),
        isAndroid = ua.indexOf("android") > -1,
        geoTimeout = isAndroid ? 15000 : 5000;

      navigator.geolocation.getCurrentPosition(
        (position: any) => {
          resolve({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
        },
        (error: any) => {
          reject(error);
          toast.error("현재 위치를 받기 위해 위치 권한을 허용해주세요.");
        },
        { enableHighAccuracy: true, maximumAge: 3000, timeout: geoTimeout }
      );
    } else {
      toast.error("브라우저에서 위치 정보를 지원하지 않아요.");
      reject(new Error("Geolocation API를 지원하지 않는 브라우저입니다."));
    }
  });
};

export const calculateDistance = (
  lat1: number,
  lng1: number,
  lat2: number,
  lng2: number
) => {
  const R = 6371;
  const dLat = (lat2 - lat1) * (Math.PI / 180);
  const dLon = (lng2 - lng1) * (Math.PI / 180);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * (Math.PI / 180)) *
    Math.cos(lat2 * (Math.PI / 180)) *
    Math.sin(dLon / 2) *
    Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c;
  return distance;
};

export const logToServer = (oData: any) => {
  let oPost = {
    log: JSON.stringify(oData),
  };
  // UtilController.logToServer(oPost)
};

export const padZero = (number: number) => {
  return number < 10 ? "0" + number : number.toString();
};

export const pad = (value: string, char: string, length: number, side?: 'right' | 'left' | 'both') => {
  side = typeof side === 'undefined' ? 'right' : side;

  let padding = '';
  let required = Math.floor(length) - value.toString().length;

  while (required > 0) {
    required -= 1;

    if (side === 'left') value = char + value;
    if (side === 'right') value = value + char;

    if (side === 'both') {
      if (required % 2 === 0) value = char + value;
      else value = value + char;
    }
  }

  return value;
};